import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/my-styles/(pages)/(list)')({
  component: lazyRouteComponent(
    () => import('../../-components/MyStylesLayout'),
    'MyStylesLayout',
  ),
});
